import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
  isFirstAppointment (profId) {
    return client().get('appointments/isFirstAppointment', {profId: profId})
  },
  getAppointmentReport (appointmentId) {
    return client().get('/patientReportPDF', {params: {appointmentId: appointmentId}})
  },
  getAppointmentPrescription (appointmentId) {
    return client().get(`/prescriptions/${appointmentId}`, { responseType: 'blob' })
  },
  getNextPatientAppointments (hideLoadingIcon) {
    return client().get('/patients/appointments/next', { loading: !hideLoadingIcon })
  },
  getPastPatientAppointments ({fromDate, toDate, professionalName, appointmentType}) {
      return client().get('/patients/appointments/past', {params: {fromDate: fromDate, toDate: toDate, professionalName: professionalName, appointmentType: appointmentType}})
  },
  getAppointmentDetails (appointmentId){
    return client().get(`appointment-details/${appointmentId}`)
  },
  cancelAppointment (appointmentId, reason) {
    return client().post('PatientCancelationAppointment', { AppointmentId: appointmentId, Reason: reason })
  },
  getAppointmentRequestInfo (criteria = {profId, centerId, appointmentTypeId, serviceId}) {
    const cleanCriteria = Object.fromEntries(
      Object.entries(criteria).filter(([_, v]) => v !== undefined && v !== null && v !== '')
    )
    return client().get('appointments/appointment-requests', { params: cleanCriteria })
  },
  createAppointment (data) {
    return client().post('appointments/appointment-requests', data)
  }
}


// WEBPACK FOOTER //
// ./src/repositories/AppointmentsRepository.js